// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';
import { UniquenessNotes } from '../../../../../types/apolloType';
import UniquenessQuestion from './UniquenessQuestion';

type Props = {
  i18nPath: string,
  notes: UniquenessNotes
};

type State = {};

class UniquenessSurvey extends React.Component<Props, State> {

  getAllUniquenessAnswers = (): Node[] =>
    [1, 2, 3, 4].map((value) => (
      <UniquenessQuestion
        i18nPath={`${this.props.i18nPath}.question${value}`}
        note={this.props.notes[`note${value}`]}
      />
    ));

  render() {
    return (
      <div className="uniqueness-survey">
        <div className="survey-title">
          <Translate value={`${this.props.i18nPath}.title`} />
        </div>
        {this.getAllUniquenessAnswers()}
      </div>
    );
  }
}

export default UniquenessSurvey;